import React, { PureComponent } from 'react';
import { encodeForURI } from 'appSrc/utils';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import TextTruncate from 'react-text-truncate';
import { Link } from 'react-router-dom';
import style from './styles/style.module.css';


class ProductCard extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            deetLines: 2,
        };
    }
    static getDerivedStateFromProps( props ) {
        var deetLines = 3;
        if( props.screenType === 'mobile' ) {
            deetLines = 2;
        }
        return { deetLines };
    }
    render() {
        const { product } = this.props;
        const productSlug = `/app/products/${ product.desireid }/${ encodeForURI(product.title) }`;

        var lines = 3;
        if( this.props.screenType === 'mobile' ) {
            lines = 2;
        }

        return (
            <div className={ `${ style.productRowItem } ${ this.props.className }`.trim() }
            style={ { ...this.props.style } }>
                <Link to={ productSlug }>
                    <div className={ style.imageWrapper }>
                        <img src={ product.image } />
                    </div>
                    <div className={ style.details }>
                        <span className={ style.price }>${ product.price }</span>
                        <TextTruncate text={ product.title }
                        title={ product.title } line={ lines }
                        containerClassName={ style.title } />
                    </div>
                </Link>
            </div>
        );
    }
}
ProductCard.propTypes = {
    product: PropTypes.object.isRequired,
};
ProductCard.defaultProps = {
    className: '',
};

const mapStateToProps = ( state ) => {
    return {
        screenType: state.screenSize.type,
    };
};

export default connect( mapStateToProps )( ProductCard );
